var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Solid_24 / Heart-pink"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.45916 11.3461C0.960775 7.65385 3.30575 3.5 6.94036 3.5C8.9722 3.5 10.6201 4.42308 12 6.26923L12.1739 6.04327C13.5179 4.34776 15.1125 3.5 17.0596 3.5C20.6943 3.5 23.0392 7.65385 21.5408 11.3461C20.916 12.8859 19.4897 14.7451 17.262 16.924C15.9316 18.2252 14.3136 19.6042 13.2259 20.5041C12.5122 21.0946 11.4878 21.0946 10.7741 20.5041C9.68643 19.6042 8.06838 18.2252 6.73799 16.924C4.51028 14.7451 3.084 12.8859 2.45916 11.3461Z",
    fill: "#FF3D8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPink);
export default __webpack_public_path__ + "static/media/heart-pink.698cdb3c27e74ad570aec8f81ded6051.svg";
export { ForwardRef as ReactComponent };